import React, { useId, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MessageSquarePlus, X } from "lucide-react";
import { isLoggedIn } from "../../Services/AuthService";
import ConsultationReviewForm from "./ConsultationReviewForm";
import "./Reviews.css";

const HomeReviewEntry = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const id = useId();
  const loggedIn = isLoggedIn();
  const [open, setOpen] = useState(params.get("review") === "true" && loggedIn);
  const [started, setStarted] = useState(open);
  const toggle = () => {
    if (!loggedIn) { navigate("/login", { state: { from: "/?review=true" } }); return; }
    setStarted(true);
    setOpen((value) => !value);
  };

  return <div className="review-home-entry iran-sans" dir="rtl">
    <div className="review-row">
      <p className="review-muted m-0">شما هم تجربه‌تان را با ما در میان بگذارید.</p>
      <button type="button" className="review-button" onClick={toggle} aria-expanded={open} aria-controls={`${id}-entry`}>
        {open ? <X size={18} aria-hidden="true" /> : <MessageSquarePlus size={18} aria-hidden="true" />}
        {open ? "بستن فرم نظر" : "ثبت نظر"}
      </button>
    </div>
    {loggedIn && started && <div id={`${id}-entry`} hidden={!open}><ConsultationReviewForm /></div>}
  </div>;
};

export default HomeReviewEntry;
